import { IconAlertOctagonFilled, IconAlertTriangle, IconChecks, IconInfoCircle } from "@tabler/icons-react";
import { PropsWithChildren } from "react";

import styles from "~/components/Alert.module.css";
import { Alert } from "~/ui";

enum AlertType {
  DANGER = "danger",
  INFO = "info",
  WARNING = "warning",
  DIMMED = "dimmed",
  SUCCESS = "success",
}

type AlertProps = {
  title?: string;
  icon?: JSX.Element;
  showIcon?: boolean;
};

type AlertBaseProps = {
  icon: JSX.Element;
  showIcon?: boolean;
  title?: string;
  type: AlertType;
};

const AlertBase = (props: PropsWithChildren<AlertBaseProps>) => {
  let alertColor = "";
  switch (props.type) {
    case AlertType.DANGER:
      alertColor = "red";
      break;
    case AlertType.INFO:
      alertColor = "primary";
      break;
    case AlertType.WARNING:
      alertColor = "yellow";
      break;
    case AlertType.SUCCESS:
      alertColor = "green";
      break;
    case AlertType.DIMMED:
      alertColor = "gray";
      break;
  }

  return (
    <Alert
      color={alertColor}
      icon={props.showIcon ? props.icon : null}
      radius="md"
      className={styles.appAlert}
      bodyClassName={styles.appAlertBody}
      title={props.title}
      variant="light"
    >
      {props.children}
    </Alert>
  );
};

export const DangerAlert = ({ showIcon = true, ...props }: PropsWithChildren<AlertProps>) => (
  <AlertBase icon={props.icon ?? <IconAlertOctagonFilled />} showIcon={showIcon} title={props.title} type={AlertType.DANGER}>
    {props.children}
  </AlertBase>
);

export const InfoAlert = ({ showIcon = true, ...props }: PropsWithChildren<AlertProps>) => (
  <AlertBase icon={props.icon ?? <IconInfoCircle />} showIcon={showIcon} title={props.title} type={AlertType.INFO}>
    {props.children}
  </AlertBase>
);

export const WarningAlert = ({ showIcon = true, ...props }: PropsWithChildren<AlertProps>) => (
  <AlertBase icon={props.icon ?? <IconAlertTriangle />} showIcon={showIcon} title={props.title} type={AlertType.WARNING}>
    {props.children}
  </AlertBase>
);

export const DimmedAlert = ({ showIcon = true, ...props }: PropsWithChildren<AlertProps>) => (
  <AlertBase icon={props.icon ?? <IconInfoCircle />} showIcon={showIcon} title={props.title} type={AlertType.DIMMED}>
    {props.children}
  </AlertBase>
);

export const SuccessAlert = ({ showIcon = true, ...props }: PropsWithChildren<AlertProps>) => (
  <AlertBase icon={props.icon ?? <IconChecks />} showIcon={showIcon} title={props.title} type={AlertType.SUCCESS}>
    {props.children}
  </AlertBase>
);
